import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="container" style={{ padding: '24px 16px 48px' }}>
      <h1 style={{ margin: 0 }}>Page not found</h1>
      <p style={{ color: 'var(--muted)' }}>
        The page you’re looking for doesn’t exist.
      </p>
      <Link className="btn" to="/">
        Go home
      </Link>
    </main>
  );
}

